// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","TextLiveStatus":"_2ZEEwP","isStandalone":"_1qIv-t","fadeInFrames":"_3rkBq7"};